<template>
    <div>
        <p class="modal-heading mb-2">Session expired</p>
        <p class="mb-4">The session timer has expired. You've been redirected to the Test Details page, and the test will need recreating.</p>
        <button @click="$emit('close')" class="btn btn-success btn-lg lg-shadow w-100">Continue</button>
    </div>
</template>

<script>
export default {
    name: 'SessionExpiredModalComponent'
}
</script>